export default "__VITE_ASSET__BG5jOKZx__"